import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as selectedLegalEntityState from '../reducers';
import * as selectedLegalEntityReducer from '../reducers/selected-legal-entity.reducer';

export const getSelectedLegalEntity = createSelector(
  selectedLegalEntityState.getSelectedLegalEntityState,
  selectedLegalEntityReducer.getSelectedLegalEntity
);

export const getIsSideNavEnabled = createSelector(
  selectedLegalEntityState.getSelectedLegalEntityState,
  selectedLegalEntityReducer.getIsSideNavEnabled
);

export const getIsSideNavHidden = createSelector(
  selectedLegalEntityState.getSelectedLegalEntityState,
  selectedLegalEntityReducer.getIsSideNavHidden
);

export const getRouteTracked = createSelector(
  selectedLegalEntityState.getSelectedLegalEntityState,
  selectedLegalEntityReducer.getTrackRoutes
);
